import React from 'react';
import './card.css';
import Popup from '../popup/Popup';
import { IPopupProps } from '../popup/Popup';
import { Logger } from '@elyx-code/common-ts-utils';

interface CardProps {
	onClick?: (...args: any[]) => any;
	disabled?: boolean;
	children?: React.ReactNode;
	tooltip?: React.ReactNode;
	id?: string;
	popupOptions?: IPopupProps;
}

const Card: React.FC<CardProps> = ({
	onClick,
	disabled,
	tooltip,
	id,
	popupOptions,
	children,
}) => {
	let resolvedId = id;

	if (!id && !popupOptions?.anchorQuerySelector) {
		resolvedId = 'card-popup--' + Math.random().toString(36).substring(2, 9);
	}

	if (!resolvedId && !popupOptions?.anchorQuerySelector) {
		Logger.warn(
			'Card component: No id or anchorQuerySelector provided for tooltip. Tooltip will not work.'
		);
	}

	return (
		<>
			<div
				onClick={onClick}
				id={resolvedId}
				className={`card-background card-size`}
				style={
					disabled ? { opacity: 0.6, transform: 'none', cursor: 'unset' } : {}
				}
			>
				{children}
			</div>
			{tooltip && (
				<Popup
					anchorQuerySelector={`#${resolvedId}`}
					placement='bottom'
					closeDelay={100}
					{...popupOptions}
				>
					{tooltip}
				</Popup>
			)}
		</>
	);
};

export default Card;
